import { Button } from "@mui/material";
import { Link } from "react-router-dom";
import CustomTextField from "../../Custom/CustomTextField";

const RegisterFormContent = ({ handleSubmit, formData, handleInputChange }) => {
  return (
    <div className="form-container">
      <form onSubmit={handleSubmit} name="register-form">
        <div className="access-header">
          <h2 className="form-title">Create Your Account</h2>
          <p>Your password needs letters, numbers, and special characters!</p>
        </div>
        <div className="name-container">
          <CustomTextField
            label="First Name"
            name="firstName"
            color="black"
            fullWidth
            required
            value={formData.firstName}
            onChange={handleInputChange}
          />
          <CustomTextField
            label="Last Name"
            name="lastName"
            color="black"
            fullWidth
            required
            value={formData.lastName}
            onChange={handleInputChange}
          />
        </div>

        <CustomTextField
          label="Email"
          type="email"
          name="email"
          color="black"
          required
          value={formData.email}
          onChange={handleInputChange}
        />
        <CustomTextField
          label="Username"
          name="username"
          color="black"
          required
          value={formData.username}
          onChange={handleInputChange}
        />
        <div className="password-container">
          <CustomTextField
            label="Password"
            type="password"
            name="password"
            required
            color="black"
            value={formData.password}
            onChange={handleInputChange}
            style={{
              marginBottom: "1rem",
            }}
          />
        </div>
        <Button
          color="black"
          variant="contained"
          disableElevation
          type="submit"
          disabled={Object.values(formData).some((x) => x === "")}
        >
          register
        </Button>
        <div className="bottom-actions">
          Have an account?
          <Link to="/login">Login</Link>
        </div>
      </form>
    </div>
  );
};

export default RegisterFormContent;
